<div class="item" #reditem>
    <section *ngIf="contact==false && report === false" class="img-cont">
        <button *ngIf="merchandise['gallery'].length > 1" (click)="swipeLeft()">←</button>
        <img *ngIf="loading===false" [src]="merchandise['gallery'][imgIndex]" alt="">
        <h1 *ngIf="loading===true">LOADING ...</h1>
        <button *ngIf="merchandise['gallery'].length > 1" (click)="swipeRight()">→</button>
    </section>
    <section *ngIf="contact==false && report === false" class="data-cont">
        <div>
            <h3>{{merchandise['item']}} | </h3>
            <h3 *ngIf="merchandise['price'] !== '0.00'" > {{merchandise['price'] | currency}}</h3>
            <h3 *ngIf="merchandise['price'] === '0.00'" >FREE</h3>

        </div>
        <!-- <p>Location: {{merchandise['city']}}, {{merchandise['state']}}</p> -->
        <p>{{merchandise['short_details']}}</p>

    </section>
    <form *ngIf="contact==true" [formGroup]="messageForm" (ngSubmit)="submitMessage($event, merchandise)">
        <input type="text" placeholder="Your Name" formControlName="from_shopper">
        <input type="text" placeholder="Your Email" formControlName="email">
        <input type="text" placeholder="Title" formControlName="title">
        <textarea name="" id="" cols="30" rows="10" placeholder="Message" formControlName="message"></textarea>
        <button [disabled]="!messageForm.valid">Submit</button>
        <div class="loading" *ngIf="submitted==='loading'">
            <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
            <h1>SENDING...</h1>
        </div>
        <div *ngIf="submitted==='submitted'">
            <h1>SUCCESS!</h1>
        </div>
    </form>

    <form class="reportForm" *ngIf="report==true" [formGroup]="reportForm" (ngSubmit)="submitReport($event, merchandise)">
        <input type="text" placeholder="Your Name" formControlName="from_shopper">
        <input type="text" placeholder="Your Email" formControlName="email">
        <input type="text" placeholder="Title" formControlName="title">
        <textarea name="" id="" cols="30" rows="10" placeholder="Message" formControlName="message"></textarea>
        <button [disabled]="!reportForm.valid">Submit</button>
        <div class="loading" *ngIf="submitted==='loading'">
            <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
            <h1>SENDING...</h1>
        </div>
        <div *ngIf="submitted==='submitted'">
            <h1>SUCCESS!</h1>
        </div>
    </form>
    <div class="buttons">
        <button routerLink='/details/{{merchandise["id"]}}'>More Info</button>
        <button class="report" (click)="reportChange(!report)" #reportButton>Report</button>
        <button (click)="contactChange(!contact)" #contactButton>Contact</button>

    </div>
</div>
